import { useEffect, useState } from "react";
import { CssBaseline } from "@mui/material";
import { Suspense } from "react";
import Router from "./routes";
import ThemeConfig from "./theme";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import SessionCheck from "pages/Session/SessionCheck";
import { getProfile } from "actions/profile";
import {
  Loader,
  NewUpdateModal,
  NoNetworkModal,
} from "empower-energy-owner-components";
import { clearVersion, getVersion, reconcileVersion } from "actions/version";
import { checkStorage } from "actions/session";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Maintenance from "pages/Static/Maintenance";
import { GAListener } from "analytics";

function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [showNoNetworkModal, setShowNoNetworkModal] = useState(false);

  const challenge = useSelector((state) => state.session.challenge);
  const session = useSelector((state) => state.session.session);
  const isNewVersion = useSelector((state) => state.version?.isNewVersion);
  const newVersionDescription = useSelector(
    (state) => state.version?.description
  );
  const maintenance = useSelector((state) => state.version?.maintenance);

  useEffect(() => {
    dispatch(checkStorage());
  }, []);

  useEffect(() => {
    setShowNoNetworkModal(!window.navigator.onLine);
  }, []);

  useEffect(() => {
    if (challenge === "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED") {
      navigate("/first-login");
    } else if (challenge === "RESET_PASSWORD") {
      navigate("/reset-password");
    } else {
      if (
        session &&
        ["/", "/login", "/first-login", "/change-password"].includes(
          location.pathname
        )
      ) {
        navigate("/home");
      }
    }
  }, [challenge, session]);

  useEffect(() => {
    if (session) {
      dispatch(getProfile());
    }
  }, [session, dispatch]);

  useEffect(() => {
    dispatch(getVersion());
    const interval = setInterval(() => {
      dispatch(getVersion());
    }, 1000 * 60 * 15);

    return () => {
      clearInterval(interval);
    };
  }, [dispatch]);

  const updateApp = () => {
    dispatch(
      reconcileVersion(() => {
        // Timeout required or updated state
        // is not stored before reload
        setTimeout(function () {
          window.location.reload();
        }, 100);
      })
    );
  };

  const clearNewVersion = () => {
    dispatch(clearVersion());
  };

  return (
    <ThemeConfig>
      {isNewVersion && (
        <NewUpdateModal
          open={isNewVersion}
          description={newVersionDescription}
          onClose={clearNewVersion}
          onClickRefresh={updateApp}
        />
      )}
      {showNoNetworkModal && (
        <NoNetworkModal
          open={showNoNetworkModal}
          onClose={() => setShowNoNetworkModal(false)}
        />
      )}
      <CssBaseline />
      <SessionCheck />
      <Suspense fallback={<Loader show={true} fullPage={true} />}>
        <Router>
          <GAListener />
        </Router>
      </Suspense>
      <ToastContainer
        autoClose={3000}
        pauseOnFocusLoss={false}
        pauseOnHover={false}
      />
      {maintenance && <Maintenance />}
    </ThemeConfig>
  );
}

export default App;
